export enum DocumentPreferenceInfoType {
    BrokerDetails,
    ComplaintsInformation,
    EvidenceOfResearch,
}
